import { booleanAttribute, Component, Input } from '@angular/core';
import { CartItem } from '../../../../models/cart.model';
import { Partner } from '../../../../models/global';
import { ReservationCountdownComponent } from '../../reservation-countdown/reservation-countdown.component';

@Component({
  selector: 'app-cw-card-header',
  templateUrl: './cw-card-header.component.html',
  styleUrls: ['./cw-card-header.component.scss'],
  imports: [ReservationCountdownComponent]
})
export class CwCardHeaderComponent {

  @Input({ transform: booleanAttribute }) showHeader = true;
  @Input() title: string;
  @Input() subtitle: string;
  @Input({ transform: booleanAttribute }) showReservationCountdown = false;
  @Input() partner: Partner;
  @Input() cart: CartItem[];
}
